module.exports = __webpack_public_path__ + "static/media/boss-back-door.2c4d1aa1.png";